<template>
  <b-container id="the-story">
    <div class="story-container">
      <div class="story-container-inner">
        <h1>The Story</h1>
        <div class="separator" />
        <p class="no-margin">
          Black History Month is a moment to celebrate and elevate those who’ve
          made innumerable contributions to the continued advancement of Black
          Americans.
        </p>
        <p>
          Within the Chicago Cubs organization, we can point directly to
          numerous icons and trailblazers who broke barriers and paved the way
          for future generations of Black American ballplayers to succeed in the
          major leagues. Among them are Cubs legends Buck O’Neil and Ernie
          Banks.
        </p>
        <p>
          Today, and every day, we celebrate these heroes and give our respect.
        </p>
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "TheStory",
};
</script>

<style lang="scss" scoped>
#the-story {
  padding-bottom: 100px;
  @media (max-width: $md) {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 50px;
  }
  .story-container {
    display: flex;
    background-image: url("~@/assets/images/bg/texture_wide.png");
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-position: center;
  }
  .story-container-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding-top: 58px;
    padding-bottom: 74px;
    padding-left: 15px;
    padding-right: 15px;
    box-shadow: 0 6px 30px 0px rgba(0, 0, 0, 0.3);

    @media (max-width: $md) {
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 48px;
      padding-bottom: 44px;
    }
    h1 {
      font-family: Poppins-Bold;
      font-size: 34px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: 42px;
      text-transform: uppercase;
    }
    .separator {
      width: 115px;
      height: 4px;
      background: #eaeaea;
      margin-top: 15px;
      margin-bottom: 15px;
    }
    p {
      width: 852px;
      max-width: 100%;
      font-family: AvenirNext-Medium;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      line-height: 31px;
      margin-top: 60px;
    }
    .no-margin {
      margin: 0 !important;
    }
  }
}
</style>

